import { Flex, Stack } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { ReactNode } from "react";
import { dasherize } from "underscore.string";

type MetadataProp = {
  title: string;
  text: ReactNode;
  type?: string;
};

type ActivityDetailsMetadataPropProps = {
  prop: MetadataProp;
};

const LinkPropValue = ({ prop }: ActivityDetailsMetadataPropProps) => (
  <a href={prop.text as string} target="_blank" rel="noopener noreferrer">
    {prop.text}
  </a>
);

const getAvailabilityFlexProps = (isAvailability: boolean) =>
  isAvailability
    ? { alignItems: "start" as const, direction: "column" as const }
    : { alignItems: "center" as const };

const TextPropValue = ({ prop }: ActivityDetailsMetadataPropProps) => {
  const isAvailability = prop.type === "availability";
  const isLocation = prop.title === "Location";

  return (
    <Flex {...getAvailabilityFlexProps(isAvailability)}>
      {isLocation && <Icon name="location" size="md" />}
      <span style={{ whiteSpace: "pre-line" }}> {prop.text} </span>
    </Flex>
  );
};

const MetadataPropValue = ({ prop }: ActivityDetailsMetadataPropProps) =>
  prop.type === "link" ? <LinkPropValue prop={prop} /> : <TextPropValue prop={prop} />;

export const ActivityDetailsMetadataProp = ({ prop }: ActivityDetailsMetadataPropProps) => (
  <Stack
    gap="spacingMd"
    key={prop.title}
    data-qa-id={`activity-details-metadata-prop${dasherize(prop.title)}`}
  >
    <Typography variant="h6" clipOverflow>
      {prop.title}
    </Typography>
    <Typography variant="bodyRegular">
      <MetadataPropValue prop={prop} />
    </Typography>
  </Stack>
);
